/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormEditCreateUpdateMasterDataFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/masterdata/create-update/form-edit-create-update-masterdata-field-dialog.component';
/* eslint-enable */

/**
 * MasterData field implementation.
 */
export class FormEditMasterDataFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateMasterDataFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateMasterDataFieldDialogComponent)
      .create(this.injector);
  }

}
